<div class="admsb-encabezado">
  <ng-container *ngIf="!cargandoTitular; else cargandoTitularTpl">
    <div class="admsb-encabezado__fila-superior">
      <div class="admsb-encabezado__nombre">
        <span class="admsb-encabezado__nombre-texto">{{ titular.nombreCompleto }}</span>
        <span class="admsb-encabezado__fecha">
          <img src="assets/icons/ico-calendario-outline.svg" alt="">
          <span
            class="admsb-encabezado__fecha-label">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_FECHACREACION' | translate }}</span>
          <span class="admsb-encabezado__fecha-valor">{{ titular.fechaCreacion || '--' }}</span>
        </span>
      </div>
      <div class="admsb-encabezado__chips">
        <span class="admsb-chip" [ngClass]="metodo.colorClase"
              *ngFor="let metodo of titular.metodosHabilitados">{{ metodo.nombre | uppercase }}</span>
        <span class="admsb-encabezado__usuario" *ngIf="titular.usuario">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_USUARIO' | translate }}
          <span class="admsb-chip admsb-chip--verde">{{ titular.usuario | uppercase }}</span>
        </span>
        <!-- <button type="button" class="btn-action-premium ds-btn-icono-editar"
                title="{{ 'BTN_EDITAR' | translate }}">
          <span class="ds-icono-editar"></span>
        </button> -->
      </div>
    </div>

    <div class="admsb-encabezado__datos">
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <i class="fa fa-id-card-o" aria-hidden="true"></i>
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CEDULA' | translate }}
        </span>
        <span
          class="admsb-dato__valor">{{ titular.numeroDocumento ? (titular.numeroDocumento | miles) : '' }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <i class="fa fa-mobile" aria-hidden="true"></i>
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TELEFONO' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ titular.telefono | telefono }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <i class="fa fa-envelope-o" aria-hidden="true"></i>
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CORREO' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ titular.correo }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-ocupacion.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_OCUPACION' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ titular.ocupacion }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-actividad-economica.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVIDADECONOMICA' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ titular.actividadEconomica }}</span>
      </div>
    </div>
  </ng-container>
  <ng-template #cargandoTitularTpl>
    <div class="ds-cargando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
      <span>{{ 'LBL_CARGANDO' | translate }}</span>
    </div>
  </ng-template>
</div>
